/**
 * Logger utility for consistent logging across the application
 */
export const logger = {
  log: (...args) => {
    if (import.meta.env.DEV) {
      console.log('[Neovision Platform]', ...args);
    }
  },
  error: (...args) => {
    console.error('[Neovision Platform Error]', ...args);
  },
  warn: (...args) => {
    if (import.meta.env.DEV) {
      console.warn('[Neovision Platform Warning]', ...args);
    }
  },
};
